module.exports = __webpack_public_path__ + "assets/parents.836f0a6674ce8d7298f1eb52c967438c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/services/parents.jpg
// module id = 314
// module chunks = 0